import { default as LatestBehancePost } from './LatestBehancePost';

export default LatestBehancePost;
